import ky from './kyextended';
import { REGISTER_URI, REGISTER_URL_COUPON } from '../constants/APIConstants';


const registerUser = (userDetails) => ky.post(REGISTER_URI, {json: userDetails}).json();

export const couponRegister = (userDetails) => ky.post(REGISTER_URL_COUPON, {json: userDetails}).json();

export default registerUser;